import { type FC } from 'react'
import { Link } from 'react-router-dom'

import logo from '@/assets/images/logotipo.png'
import logoResumido from '@/assets/images/logotipoResumido.png'
import logoCobranding from '@/assets/images/logotipoCoBranding.png'

import './index.scss'
interface LogoProps {
  collapsed?: boolean
}

export const Logo: FC<LogoProps> = ({ collapsed = false }) => {
  return (
    <div className='isoLogoWrapper'>
      <h3>
        <Link to='/'>
          <img
            alt='cobranding'
            src={logoCobranding}
            style={{ display: 'none' }}
          />
          <img
            alt='logo'
            src={collapsed ? logoResumido : logo}
            style={{ maxHeight: collapsed ? '40px' : '55px' }}
          />
        </Link>
      </h3>
    </div>
  )
}
